// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F3RGe","label":"styles_label__1OYh8"};